<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <!--<div class="left-side-switch" onclick="sideChangeStatus();">
      <i class="fa" :class="status ? 'fa-angle-double-right':'fa-angle-double-left'"></i>
    </div>-->
    <div>
      <h6
        class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7"
      >
        {{ $t("mall.条件筛选") }}
      </h6>
      <div class="mg-t-10 pd-x-10 mg-b-40">
        <div class="mg-b-10 form-group">
          <select-distributor
            class="mg-b-10"
            :noLike="true"
            :key_word="keyDistributorName"
            @changeKeyword="changeName"
            @keywordEnter="filtrateName"
            @keywordFilter="filtrateNameDefault"
          />
        </div>
        <div class="form-group mg-b-10">
          <input
            type="text"
            :placeholder="$t('mall.请输入支付平台交易号')"
            class="form-control form-control-dark tx-13"
            v-model="keyTradeCode"
            @keyup.enter="filtrate"
          />
        </div>
        <div class="form-group mg-b-10">
          <input
            type="text"
            :placeholder="$t('mall.请输入订单号')"
            class="form-control form-control-dark tx-13"
            v-model="keyOrderCode"
            @keyup.enter="filtrate"
          />
        </div>
        <div class="form-group mg-b-10">
          <input
            type="text"
            :placeholder="$t('mall.请输入系统交易号')"
            class="form-control form-control-dark tx-13"
            v-model="keyCode"
            @keyup.enter="filtrate"
          />
        </div>
        <div class="mg-b-10 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            @change="filtrate"
            v-model="keyType"
          >
            <option value="">{{ $t("mall.类型") }}</option>
            <option v-for="(s, k) in payTypeArr" :key="k" :value="k">
              {{ $t(s) }}
            </option>
          </select>
        </div>
        <div class="mg-b-10 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            @change="filtrate"
            v-model="keyStatus"
          >
            <option value="">{{ $t("mall.状态") }}</option>
            <option v-for="(s, k) in payStatus" :key="k" :value="k">
              {{ $t(s) }}
            </option>
          </select>
        </div>
        <div class="form-group mg-b-10">
          <div class="datepicker-group">
            <div class="input-group">
              <span class="input-group-addon">
                <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
              </span>
              <input
                v-model="keyDateFrom"
                data-id="datepicker-from"
                type="text"
                class="form-control-dark form-control fc-datepicker"
                :placeholder="$t('mall.起始日期')"
              />
            </div>
            <div class="input-group">
              <span class="input-group-addon">
                <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
              </span>
              <input
                v-model="keyDateTo"
                data-id="datepicker-to"
                type="text"
                class="form-control form-control-dark fc-datepicker"
                :placeholder="$t('mall.截止日期')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary btn-block tx-uppercase tx-11 tx-spacing-2 tx-medium"
      @click="filtrate"
    >
      {{ $t("mall.筛 选") }}
    </button>
  </div>
</template>

<script>
import SelectDistributor from "@components/supplier/select-distributor-2.vue"; //客户搜索
export default {
  props: [
    "status",
    "key_distributorId",
    "key_distributorName",
    "key_status",
    "key_code",
    "key_ordercode",
    "key_tradecode",
    "key_type",
    "date_from",
    "date_to",
  ],
  data() {
    return {
      keyDistributorName: "",
      keyDistributorId: "",
      keyDistributorName1: "",
      keyDistributorId1: "",
      keyStatus: "",
      keyCode: "",
      keyType: "",
      keyOrderCode: "",
      keyTradeCode: "",
      keyDateFrom: "",
      keyDateTo: "",
      payTypeArr: arrDict.afterSaleType,
      payStatus: arrDict.accountStatus,
    };
  },
  components: {
    "select-distributor": SelectDistributor,
  },
  watch: {
    key_distributorId: function () {
      this.keyDistributorId = this.key_distributorId;
      this.keyDistributorId1 = this.key_distributorId;
    },
    key_distributorName: function () {
      this.keyDistributorName = this.key_distributorName;
      this.keyDistributorName1 = this.key_distributorName;
    },
    key_status: function () {
      this.keyStatus = this.key_status;
    },
    key_code: function () {
      this.keyCode = this.key_code;
    },
    key_ordercode: function () {
      this.keyOrderCode = this.key_ordercode;
    },
    key_tradecode: function () {
      this.keyTradeCode = this.key_tradecode;
    },
    key_type: function () {
      this.keyType = this.key_type;
    },
    date_from: function () {
      this.keyDateFrom = this.date_from;
    },
    date_to: function () {
      this.keyDateTo = this.date_to;
    },
  },
  methods: {
    filtrate() {
      if (!this.keyDistributorId) {
        this.keyDistributorName = "";
        this.keyDistributorId = this.keyDistributorId1;
        this.keyDistributorName = this.keyDistributorName1;
        this.$emit(
          "filtrate",
          this.keyDistributorName1,
          this.keyDistributorId1,
          this.keyCode,
          this.keyStatus,
          this.keyType,
          this.keyOrderCode,
          this.keyTradeCode,
          this.keyDateFrom,
          this.keyDateTo
        );
      } else {
        if (!this.keyDistributorId1) {
          this.$emit(
            "filtrate",
            this.keyDistributorName,
            this.keyDistributorId,
            this.keyCode,
            this.keyStatus,
            this.keyType,
            this.keyOrderCode,
            this.keyTradeCode,
            this.keyDateFrom,
            this.keyDateTo
          );
        } else {
          this.keyDistributorName = "";
          this.keyDistributorId = this.keyDistributorId1;
          this.keyDistributorName = this.keyDistributorName1;
          this.$emit(
            "filtrate",
            this.keyDistributorName,
            this.keyDistributorId,
            this.keyCode,
            this.keyStatus,
            this.keyType,
            this.keyOrderCode,
            this.keyTradeCode,
            this.keyDateFrom,
            this.keyDateTo
          );
        }
      }
    },
    filtrateName(name, id) {
      if (!id || id == "e999") {
        ShowTip(this.$t("mall.没有匹配的客户"), "danger");
        this.keyDistributorName = "";
        this.keyDistributorId = "";
      } else {
        //清空按联系人
        this.keyDistributorName = name;
        this.keyDistributorId = id;
      }
      this.filtrate();
    },
    filtrateNameDefault(name, id) {
      this.keyDistributorName1 = name;
      this.keyDistributorId1 = id;
    },
    changeName(name, id) {
      this.keyDistributorrName = name;
      this.keyDistributorId = id;
    },
    sideChangeStatus() {
      //边栏状态改变
      this.$emit("changeStatus");
    },
    datepickerSelect() {
      let vm = this;
      $("[data-id=datepicker-from]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          maxDate: 0,
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-to]"))
              .datepicker("option", "minDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.keyDateFrom = selectedDate;
          },
        });
      });
      $("[data-id=datepicker-to]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          maxDate: 0,
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-from]"))
              .datepicker("option", "maxDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.keyDateTo = selectedDate;
          },
        });
      });
    },
  },
  mounted() {
    this.datepickerSelect();
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  updated() {
    this.datepickerSelect();
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
};
</script>
